import {
    Directive,
    Input,
    TemplateRef,
    ViewContainerRef,
    OnDestroy
} from '@angular/core';
import {RoleService} from '@services/role.service';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appHasRole]',
    standalone: true
})
export class HasRoleDirective implements OnDestroy {
    private sub: Subscription;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private roleService: RoleService
    ) {}

    @Input() set appHasRole(allowedRoles: string[]) {
        this.sub?.unsubscribe();
        this.sub = this.roleService.role$.subscribe((role) => {
            this.viewContainer.clear();
            if (
                allowedRoles
                    .map((r) => r.toLowerCase())
                    .includes(role.toLowerCase())
            ) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
}
